import {default as axiosRetry, isSafeRequestError} from 'axios-retry'
import axios from 'axios'

// const backendBaseURL = 'https://api.vcc.ipcomnetwork.net/'
const backendBaseURL = 'https://api.vcc-next.ipcom.ai/'

// const backendBaseURL = 'http://127.0.0.1:3030'
const wsBaseURL = 'wss://api.vcc-next.ipcom.ai/wss'

export const STEP_TYPES = {
  TTS: 1,
  Playback: 2,
  WebVariable: 3,
  Record: 4,
  SimpleAction: 5,
  RecordDigits: 6,
  Transfer: 7,
  Hangup: 8,
  Return: 9,
  Begin: 10,
  Repeat: 11,
  ASRStep: 12,
  Delay: 13,
  properties: {
    1: {name: 'Text to Speech', value: 1, code: 'TTS'},
    2: {name: 'Playback', value: 2, code: 'Playback'},
    3: {name: 'Web Variable', value: 3, code: 'WebVariable'},
    4: {name: 'Record', value: 4, code: 'Record'},
    5: {name: 'Simple Action', value: 5, code: 'SimpleAction'},
    6: {name: 'Record Digits', value: 6, code: 'RecordDigits'},
    7: {name: 'Transfer', value: 7, code: 'Transfer'},
    8: {name: 'Hangup', value: 5, code: 'Hangup'},
    9: {name: 'Return', value: 5, code: 'Return'},
    10: {name: 'Begin', value: 5, code: 'Begin'},
    11: {name: 'Repeat', value: 5, code: 'Repeat'},
    12: {name: 'ASR', value: 12, code: 'ASRStep'},
    13: {name: 'Delay', value: 13, code: 'Delay'}
  }
}

export const TRANSITIONS = {
  DIGITS: 1,
  NEXT: 2,
  ASR: 3,
  VARCOMP: 4,
  properties: {
    1: {name: 'Digits', value: 1, code: 'Digits'},
    2: {name: 'Next', value: 2, code: 'Next'},
    3: {name: 'ASR', value: 3, code: 'ASR'},
    4: {name: 'VarComp', value: 4, code: 'VarComp'}
  }
}

export const WAIT_TIME_LIMIT = 90
export const RETRY_TIME_LIMIT = 300

function createAxiosInstance () {
  const instance = axios.create({timeout: 30000, headers: {common: []}})
  delete instance.defaults.headers.common['Authorization']
  axiosRetry(instance, {retries: 5,
    retryDelay (count) {
      return Math.pow(2, count) * 500
    },
    retryCondition: isSafeRequestError
  })
  return instance
}

export async function getConfig () {
  if (process.env.NODE_ENV !== 'production') {
    return {
      wsBaseURL,
      backendBaseURL,
      softwareTitle: 'IPCOM VORTEX !!! DEV VERSION !!!'
    }
  }
  const instance = createAxiosInstance()
  const {data: conf} = await instance.get(`/conf`)
  return {
    wsBaseURL: conf.ws,
    backendBaseURL: conf.api,
    softwareTitle: conf.softwareTitle
  }
}

export async function getLogo () {
  if (process.env.NODE_ENV !== 'production') {
    return '/static/img/logo.svg'
  }
  return '/logo'
}



// WEBPACK FOOTER //
// ./src/config.js